import React from 'react';

const GrievanceRequest = () => {
  return (
    <div>
      GrievanceRequest
      GrievanceRequest
    </div>
  );
}

export default GrievanceRequest;
